var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eu-width_100 eu-display_flex emd-progress",style:({ backgroundColor: _vm.backgroundColor })},[(_vm.$slots.default)?[_vm._t("default")]:[_c('emd-progress-bar',{attrs:{"max":_vm.max,"value":_vm.value}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }